export default __webpack_public_path__ + "static/media/privacy.22a5f333.svg";